import React from 'react';
import { GenericAccessPage as GenericAccessPageComponent } from './GenericAccessPage';
import { accessPageConfigs } from '../../config/accessPageConfig';

export const JenkinsAccess = () => <GenericAccessPageComponent {...accessPageConfigs.jenkins} />;
export const AzureAccess = () => <GenericAccessPageComponent {...accessPageConfigs.azure} />;
export const GcpAccess = () => <GenericAccessPageComponent {...accessPageConfigs.gcp} />;
export const AwsAccess = () => <GenericAccessPageComponent {...accessPageConfigs.aws} />;
export const ClickhouseAccess = () => <GenericAccessPageComponent {...accessPageConfigs.clickhouse} />;
export const OpensearchAccess = () => <GenericAccessPageComponent {...accessPageConfigs.opensearch} />;
export const PostgresAccess = () => <GenericAccessPageComponent {...accessPageConfigs.postgres} />;

export { GenericAccessPage } from './GenericAccessPage';
export type { GenericAccessPageProps, ServerLink } from './GenericAccessPage';
